import { Caption, Subtitle, Subtitle2 } from 'components/Text'
import React from 'react'
import styled from 'styled-components'
import Colors from 'styles/Colors'
import { ContentfulArticle } from 'Types'
import placeholder from 'src/assets/images/resources.jpg'
import { Link } from 'gatsby'
import { formatPath } from 'sections/Resources/utils'
import media from 'styles/media'

type Props = {
  articles: ContentfulArticle[]
  currentArticle: ContentfulArticle
}

const Related: React.FC<Props> = ({ articles, currentArticle }) => {
  const suggestions = [...articles]
    .filter((e) => e.title !== currentArticle.title)
    .slice(0, 4)

  return (
    <Wrapper>
      <Title>Related articles</Title>
      <Articles>
        {suggestions.map((e) => {
          return (
            <Link to={`/${formatPath(e.title)}`} key={e.title}>
              <Article>
                <ArticleTitle>{e.title}</ArticleTitle>
                <Topic>{e.type}</Topic>
                <Image
                  src={
                    e.coverImage
                      ? e.coverImage.file
                        ? e.coverImage.file.url
                        : placeholder
                      : placeholder
                  }
                />
              </Article>
            </Link>
          )
        })}
      </Articles>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 1236px;
  margin-top: 96px;
  float: right;
  margin-right: 96px;
  border-top: solid 1px ${Colors.softBlack};
  @media screen and (max-width: 1370px) {
    width: 1050px;
  }
  ${media.tabletLandscape} {
    margin-right: 0;
  }
  @media screen and (max-width: 1070px) {
    width: 1010px;
  }
  ${media.tablet} {
    width: calc(100% - 96px);
    margin: 96px auto 0;
    float: none;
  }
  ${media.mobile} {
    width: calc(100% - 24px);
  }
`
const Title = styled(Subtitle2)`
  margin-top: 12px;
`
const Articles = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  ${media.mobile} {
    width: 100%;
    margin-right: 0;
    a {
      width: 100%;
    }
  }
`
const Article = styled.div`
  width: 480px;
  min-height: 132px;
  background: white;
  padding: 12px 24px 16px 162px;
  margin: 0 24px 24px 0;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${media.mobile} {
    width: 100%;
    margin-right: 0;
    padding: 12px 8px 12px 114px;
    max-width: 351px;
    min-height: 120px;
  }
`
const ArticleTitle = styled(Subtitle2)`
  margin-bottom: 12px;
  position: relative;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  overflow: hidden;
  ::before {
    content: '//';
    position: absolute;
    left: -22px;
    color: ${Colors.rossoCorsa};
  }
  ${media.mobile} {
    margin-bottom: 0;
  }
`
const Topic = styled(Caption)`
  width: fit-content;
  padding: 4px 12px;
  background: ${Colors.softBlack};
  color: white;
  ${media.mobile} {
    position: absolute;
    left: 8px;
    top: 92px;
    width: 72px;
    text-align: center;
  }
`
const Image = styled.img`
  width: 124px;
  height: calc(100% - 8px);
  position: absolute;
  top: 4px;
  left: 4px;
  object-fit: cover;
  ${media.mobile} {
    width: 72px;
    height: 72px;
    top: 8px;
    left: 8px;
  }
`
export default Related
